import { type ReactElement, useCallback } from 'react'
import * as S from './footer.styled'
import { Link } from 'react-router-dom'
import { RegulationModal } from '../modal/regulation-modal'
import { useModal } from '../../contexts/modal-context/modal-context'
import { AudioBookTermsModal } from '../modal/audio-book-terms-modal'

export function Terms (): ReactElement {
  const { openModal } = useModal()

  const handleOpenRegulation = useCallback(() => {
    openModal({
      body: <RegulationModal />
    })
  }, [])

  const handleOpenAudioBookTerms = useCallback(() => {
    openModal({
      body: <AudioBookTermsModal />
    })
  }, [])

  return <S.Terms>
    <Link to="https://www.cartaodetodos.com.br/politica-de-privacidade/" target="_blank" rel="noopener noreferrer">Política de privacidade</Link>
    <Link onClick={handleOpenRegulation} to="">Regulamento</Link>
    <Link onClick={handleOpenAudioBookTerms} to="">Termo Usuário Audio Book</Link>
  </S.Terms>
}
